<template>
  <div>
    <div class="compair-layout--box">
      <!-- header / filter -->
      <div class="compair-layout--box-header">
        <h3>Filter</h3>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.start"
              type="date"
              label="Von"
              name="from"
              :config="{
                altFormat: 'd.m.Y H:i',
                dateFormat: 'Y-m-d H:i'
              }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.end"
              type="date"
              label="Bis"
              name="to"
              :config="{
                altFormat: 'd.m.Y H:i',
                dateFormat: 'Y-m-d H:i'
              }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.campaigns"
              type="model"
              placeholder="Kampagne"
              name="campaign"
              label="Kampagnen"
              model-label="name"
              gql-query="adCampaigns"
              gql-filter-type="objectFilter"
              object-filter-attribute="search"
              multiple
              allow-null
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.userGroups"
              type="model"
              label="Benutzergruppe"
              placeholder="Benutzergruppe"
              multiple
              name="group"
              gql-query="userGroups"
              allow-null
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.vacancies"
              type="model"
              placeholder="Stelle"
              name="vacancy"
              label="Stellen"
              model-label="title"
              gql-query="vacancyPage"
              gql-filter-type="objectFilter"
              object-filter-attribute="searchQuery"
              multiple
              allow-null
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.qrCodes"
              type="model"
              placeholder="QR-Code"
              name="campaign"
              label="QR-Codes"
              model-label="name"
              gql-query="qrCodes"
              gql-filter-type="qrCodeFilter"
              object-filter-attribute="search"
              multiple
              allow-null
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.variants"
              type="model"
              placeholder="Ausprägung"
              name="Ausprägung"
              label="Ausprägung"
              model-label="name"
              gql-query="qrCodeVariants"
              multiple
              allow-null
            />
          </div>
        </div>
      </div>
      <!-- body / table -->
      <div class="compair-layout--box-body">
        <template
          v-if="
            qrCodeStats && qrCodeStats.results && qrCodeStats.results.length
          "
        >
          <table class="vx-table">
            <thead>
              <tr>
                <th
                  :key="'a' + getKey(filter.orderBy)"
                  class="cursor-pointer"
                  @click="() => orderBy('QRCODE')"
                >
                  Name
                  <template
                    v-if="filter.orderBy && filter.orderBy.by === 'QRCODE'"
                    ><i v-if="filter.orderBy.desc" class="fas fa-arrow-down"></i
                    ><i v-else class="fas fa-arrow-up"></i></template
                  ><i v-else class="fas fa-sort-alt"></i>
                </th>
                <th
                  :key="'b' + getKey(filter.orderBy)"
                  class="cursor-pointer"
                  @click="() => orderBy('CAMPAIGN')"
                >
                  Kampagne
                  <template
                    v-if="filter.orderBy && filter.orderBy.by === 'CAMPAIGN'"
                    ><i v-if="filter.orderBy.desc" class="fas fa-arrow-down"></i
                    ><i v-else class="fas fa-arrow-up"></i></template
                  ><i v-else class="fas fa-sort-alt"></i>
                </th>
                <th>Stelle</th>
                <th>Benutzergruppe</th>
                <th
                  :key="'c' + getKey(filter.orderBy)"
                  class="cursor-pointer"
                  @click="() => orderBy('VARIANT')"
                >
                  Ebene
                  <template
                    v-if="filter.orderBy && filter.orderBy.by === 'VARIANT'"
                    ><i v-if="filter.orderBy.desc" class="fas fa-arrow-down"></i
                    ><i v-else class="fas fa-arrow-up"></i></template
                  ><i v-else class="fas fa-sort-alt"></i>
                </th>
                <th
                  :key="'d' + getKey(filter.orderBy)"
                  class="cursor-pointer"
                  @click="() => orderBy('VIEWS')"
                >
                  Aufrufe
                  <template
                    v-if="filter.orderBy && filter.orderBy.by === 'VIEWS'"
                  >
                    <i v-if="filter.orderBy.desc" class="fas fa-arrow-down" />
                    <i v-else class="fas fa-arrow-up" />
                  </template>
                  <i v-else class="fas fa-sort-alt" />
                </th>
                <th
                  :key="'e' + getKey(filter.orderBy)"
                  class="cursor-pointer"
                  @click="() => orderBy('CREATEDAT')"
                >
                  Erstellt am
                  <template
                    v-if="filter.orderBy && filter.orderBy.by === 'CREATEDAT'"
                  >
                    <i v-if="filter.orderBy.desc" class="fas fa-arrow-down" />
                    <i v-else class="fas fa-arrow-up" />
                  </template>
                  <i v-else class="fas fa-sort-alt" />
                </th>
                <th>
                  <!-- download -->
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="result in qrCodeStats.results" :key="result.qrCode.id">
                <td>{{ result.qrCode.name }}</td>
                <td v-if="result.qrCode.ad_campaign">
                  {{ result.qrCode.ad_campaign.name }}
                </td>
                <td v-else>-</td>
                <td v-if="result.qrCode.vacancy">
                  {{ result.qrCode.vacancy.title }}
                </td>
                <td v-else>-</td>
                <td v-if="result.qrCode.user_group">
                  {{ result.qrCode.user_group.name }}
                </td>
                <td v-else>-</td>
                <td>{{ result.qrCode.variant.name }}</td>
                <td>{{ result.visits }}</td>
                <td>
                  {{ $d(Date.parse(result.qrCode.createdAt), "short") }}
                </td>
                <td>
                  <span
                    class="cursor-pointer"
                    @click="downloadQr(result.qrCode.id, result.qrCode.name)"
                  >
                    <i class="far fa-download"></i>
                  </span>
                  <!-- canvas must exist in order to download image -->
                  <qrcode
                    :id="result.qrCode.id"
                    :value="`${result.qrCode.qr_url}`"
                    :options="{ width: 4000 }"
                    style="display: none"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <vs-pagination
            v-model="currentPage"
            class="mt-6 md:mt-0"
            :total="totalPages"
            :max="7"
            icon-pack="fas"
            prev-icon="fa-chevron-left"
            next-icon="fa-chevron-right"
          />
        </template>
        <template v-else>Keine Ergebnisse. </template>
      </div>
    </div>
  </div>
</template>
<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";
import { paginationMixin } from "@/mixins/paginationMixin.js";

export default {
  components: { DataInput },
  mixins: [paginationMixin("qrCodeStats")],
  data() {
    return {
      currentPage: 1,
      filter: {
        start: null,
        end: null,
        campaigns: [],
        userGroups: [],
        vacancies: [],
        qrCodes: [],
        variants: [],
        orderBy: null
      }
    };
  },
  apollo: {
    qrCodeStats: {
      query: gql`
        query QrCodeStats(
          $filter: QrCodeActionFilter!
          $page: Int
          $size: Int
        ) {
          qrCodeStats(filter: $filter, page: $page, size: $size) {
            total
            results {
              qrCode {
                ad_campaign {
                  id
                  name
                }
                createdAt
                name
                id
                qr_url
                user_group {
                  id
                  name
                }
                vacancy {
                  id
                  title
                }
                variant {
                  name
                  id
                }
              }
              visits
            }
          }
        }
      `,
      variables() {
        return {
          filter: this.filter,
          page: this.currentPage,
          size: 15
        };
      },
      fetchPolicy: "network-only"
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$apollo.queries.qrCodeStats.refetch();
      }
    }
  },
  methods: {
    getKey(x) {
      return JSON.stringify(x);
    },
    orderBy(by) {
      const current = this.filter.orderBy;
      if (current && current.by === by) {
        if (current.desc) {
          this.filter.orderBy = null;
        } else {
          this.filter.orderBy.desc = true;
        }
      } else {
        this.filter.orderBy = {
          by,
          desc: false
        };
      }
    },
    downloadQr(id, name) {
      var link = document.createElement("a");
      link.download = name + ".png";
      link.href = document.getElementById(id).toDataURL();
      link.click();
    }
  }
};
</script>
<style scoped>
.fa-sort-alt {
  color: lightgrey;
}
.qr-download-col {
  text-align: end;
}
td {
  padding: 1rem;
  /* padding-bottom: 0; */
  opacity: 0.8;
}
tr + tr {
  border-top: 1px solid lightgray;
}
th {
  padding: 1rem;
  padding-bottom: 0;
  font-size: 1.125rem;
  font-weight: 400;
}
h4 {
  margin-left: 0.5rem;
}
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
